import colors from 'styles/colors';
import styled from 'styled-components';
import fonts from 'styles/fonts';
import media from 'styles/media';
import sizes from 'styles/sizes';
import CaretBase from 'components/svg/Caret';

export const FooterContainer = styled.div`
  width: 100%;
  position: sticky;
  background-color: ${colors.functional.blue};
  color: ${colors.primary.ice};
  padding: 24px 0 0;
  margin: 0 auto;
  display: flex;
  flex: 1 1 0%;
  flex-flow: column nowrap;
  place-content: flex-start;
  align-items: stretch;
  font-family: ${fonts.primary.regular};
  font-size: 14px;
`;

export const FooterWrapper = styled.div`
  margin: 0 auto;
  width: calc(100% - 60px);
  height: 100%;
  align-items: flex-start;
  display: flex;
  justify-content: center;
  flex-direction: column;
  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    max-width: 1440px;
  }
`;

export const FooterDisclaimer = styled.div`
  width: 100%;
  margin: auto;
  font-size: 14px;
  font-family: ${fonts.primary.bold};
  color: ${colors.primary.ice};
  margin-bottom: 0px;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  ${media.small`
    margin-bottom: 32px;
    `}
`;

export const FooterLink = styled.a`
  text-decoration: underline;
`;

export const FooterAccoladesItemImg = styled.img`
  width: 87px;
  height: 30px;

  @media (min-width: ${sizes.media.xxSmallMaxWidth + 1}px) {
    width: 97px;
    height: 34px;
  }
  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    width: 163px;
    height: 57px;
  }
`;

export const FooterAccolades = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  max-width: 630px;
  margin: 0 auto;
  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    margin: 60px auto;
  }
`;

export const FooterAccoladesItem = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-grow: 1;
  padding-right: 70px;
  &:last-child {
    padding-right: 0;
  }
  ${media.small`
    padding-right: 20px;
    `}
`;

export const FooterRow = styled.div`
  align-items: flex-start;
  color: ${colors.primary.ice};
  background-color: ${colors.functional.darkBlue};
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const FooterSocial = styled.div`
  text-align: center;
  display: flex;
  flex: 1 1 0%;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  max-width: 400px;
  width: 100%;
  margin: 60px auto 0px;
`;

export const FooterSocialItem = styled.a`
  align-items: center;
  display: flex;
  justify-content: center;
  &:last-child {
    padding-right: 0;
  }
`;

export const FooterSocialItemImg = styled.img`
  height: 20px;
  width: 30px;
`;

export const FooterCopyright = styled.div`
  margin-top: 40px;
`;

export const FooterGenNav = styled.div`
  margin-top: 40px;
`;

export const FooterGenNavList = styled.ul`
  text-align: center;
  margin: 0;
  padding: 0;
`;
export const FooterGenNavListItem = styled.li`
  list-style-type: none;
  display: inline-block;
  padding-left: 15px;
  padding-right: 15px;
  border-right: 1px solid rgba(255, 255, 255, 0.4);
  padding-bottom: 3px;
  &:last-child {
    border-right: none;
  }
`;

export const FooterGenNavListItemLink = styled.a`
  color: ${colors.primary.ice};
`;

export const FooterBrandLogos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: hidden;
  margin-top: 20px;
  margin-bottom: 180px;
  margin-inline: 2%;
  padding-bottom: 15px;

  @media (min-width: ${sizes.media.xSmallMaxWidth + 80}px) {
    margin-inline: 5%;
  }
  @media (min-width: ${sizes.media.tabletMinWidth}px) {
    margin-bottom: 170px;
  }
  @media (min-width: ${sizes.media.mediumMinWidth}px) {
    margin-bottom: 180px;
    margin-inline: 2%;
  }
  @media (min-width: ${sizes.media.mediumMaxWidth}px) {
    margin-bottom: 90px;
    margin-inline: 5%;
  }
`;

export const HeaderLogoLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55%;
  margin-inline: 15px;
  margin-top: 40px;
  max-width: 210px;
  position: relative;

  &:before {
    content: "";
    display: block;
    width: 50vw;
    height: 1px;
    opacity: 40%;
    background: ${colors.primary.ice};
    right: 110%;
    bottom: 10%;
    position: absolute;
  }

  &:after {
    content: "";
    display: block;
    width: 50vw;
    height: 1px;
    opacity: 40%;
    background: ${colors.primary.ice};
    left: 110%;
    bottom: 10%;
    position: absolute;
  }
}
`;

export const HeaderLogoLinkImg = styled.img`
  width: 100%;
  cursor: pointer;
`;

export const FooterLogo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const FooterLogoLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40%;
  margin-inline: 15px;
  margin-top: 40px;
  max-width: 210px;

  @media (min-width: ${sizes.media.xSmallMaxWidth + 80}px) {
    margin-inline: 20px;
  }
  @media (min-width: ${sizes.media.tabletMinWidth}px) {
    margin-inline: 15px;
  }
  @media (min-width: ${sizes.media.mediumMinWidth}px) {
    margin-inline: 50px;
  }
`;

export const FooterLogoLinkImg = styled.img`
  width: 100%;
  cursor: pointer;
`;

export const FooterNavigation = styled.div`
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: stretch;
  margin-top: 50px;
  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    flex-flow: row nowrap;
    margin-top: 0px;
  }
`;

export const FooterNavigationCatTitle = styled.div`
  text-transform: uppercase;
  color: #ffffff;
  font-size: 14px;
  letter-spacing: 2px;

  ${media.large`
        height: 40px;
        font-size: 18px;
    `}
`;

export const FooterNavigationCat = styled.div`
  padding-top: 10px;
  padding-bottom: 15px;
  padding-right: 15px;
  @media (max-width: ${sizes.media.smallMaxWidth}px) {
    position: relative;
  }
  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    &:nth-last-child(1) {
      padding-right: 0;
    }
  }

  button {
    display: none;

    @media (max-width: ${sizes.media.smallMaxWidth}px) {
      display: inline;
      position: absolute;
      padding: 12px;
      width: 100%;
      background: none;
    }
  }

  label {
    display: flex;
    flex: 1 1 0%;
    flex-flow: row nowrap;
    place-content: space-between;
    align-items: center;
    padding-bottom: 10px;
  }
`;

export const FooterNavigationCatLinks = styled.ul`
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin: 0 15px;
  padding: 0;
  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    border-bottom: none;
    margin: 0;
  }
  li {
    list-style-type: none;
    line-height: 31px;
    a {
      color: ${colors.primary.ice};
    }
  }
`;

export const FooterNavigationCatCarrot = styled.div`
  display: flex;
  transform: rotate(90deg);
  img {
    height: 12px;
    @media (min-width: ${sizes.media.smallMaxWidth}px) {
      display: none;
    }
  }
`;

export const Caret = styled(CaretBase)`
  height: 12px;
  width: 12px;
  stroke: ${colors.primary.ice};

  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    display: none;
  }
`;
